import { useEffect, useRef } from 'react'

export default function LiveChatEmbed({ html }) {
  const containerRef = useRef(null)

  useEffect(() => {
    const node = containerRef.current
    if (!node) return undefined
    node.innerHTML = ''
    const markup = String(html || '').trim()
    if (!markup) return undefined

    node.innerHTML = markup
    const scripts = Array.from(node.querySelectorAll('script'))
    scripts.forEach((oldScript) => {
      const next = document.createElement('script')
      Array.from(oldScript.attributes).forEach((attr) => {
        next.setAttribute(attr.name, attr.value)
      })
      next.textContent = oldScript.textContent
      oldScript.parentNode?.replaceChild(next, oldScript)
    })

    return () => {
      node.innerHTML = ''
    }
  }, [html])

  if (!html) return null
  return <div className="live-chat-embed" ref={containerRef} />
}
